import axios from "axios";
import {config} from "@/config/constants.js";
import jsonToFormData from "@ajoelp/json-to-formdata";
import genericStore from "../generic_store";

export default {
    namespaced: true,
    state: {
        endpoint: "carts",
        object: "cart",
        status: "",
        selected_rows: [],
        header: [
            { text: "ID", value: "id" },
            // { text: "Description", value: "description" },
            { text: "Actions", value: "actions", sortable: false }
        ],
        list: [],
        page: 1,
        total: 0,
        options: {
            itemsPerPage: 10,
            search: ""
        }
    },
    mutations: {
        ...genericStore.mutations,
        
        request(state) {
            state.status = "loading";
        },
        success(state, data) {
            state.status = "success";

            if (data && data["list"]) {
                state.list = data["list"];
            }

            if (data && data["total"]) {
                state.total = data["total"];
            }
        },
        error(state) {
            state.status = "error";
        },
        options(state, data) {
            state.options = data;
        }
    },
    actions: {
        ...genericStore.actions,

        addCart({ commit, state }, options) {
            return new Promise((resolve, reject) => {
            commit("request");
            let filter = {
                ...options
                /* search: ""*/
            };
            const formData = jsonToFormData(filter, {
            arrayIndexes: true,
            excludeNull: true,
            });
              axios
                .post(config.api_url +  "add_cart", formData)
                .then(response => {
                  commit("success", {
                    list: response.data,
                    total: parseInt(
                        response.headers["pagination-count"]
                    )
                  });
                  resolve(response.data);
                })
                .catch(err => {
                  commit("error");
                  reject(err);
                });
            });
        },
        remove({ commit, state }, id) {
            return new Promise((resolve, reject) => {
                commit("request");
                axios
                .delete(config.api_url + "remove_cart/" + id)
                .then(() => {
                    commit("success");
                    resolve();
                })
                .catch((error) => {
                    console.log(error);
                    commit("error");
                    reject(error.response.id);
                });
            });
        },

        update({ commit, state }, options) {
            console.log('llega update  ', options);
            return new Promise((resolve, reject) => {
            commit("request");
            let filter = {
                ...options
                /* search: ""*/
            };
            console.log('filter ', filter);
            const formData = jsonToFormData(filter, {
            arrayIndexes: true,
            excludeNull: true,
            });
              axios
                .put(config.api_url +  "edit_cart", formData)
                .then(response => {
                  commit("success", {
                    list: response.data,
                    total: parseInt(
                        response.headers["pagination-count"]
                    )
                  });
                  resolve(response.data);
                })
                .catch(err => {
                  commit("error");
                  reject(err);
                });
            });
        },
    },
    getters: {

        ...genericStore.getters,

        status(state) {
            return state.status;
        }
    },
    modules: {}
};
